// GENERATED by scripts/check-legacy-events.mjs --write — do not edit by hand.
// The single source of truth is the legacy dispatch tables themselves
// (msg/msg.js MSG_OBJ return, new/new.js NEW_MSG_OBJ return); this file is
// verified against them by `node scripts/check-legacy-events.mjs`.
// Dispatching any name outside these unions is a compile error — that is the
// point: MSG_OBJ[name] string dispatch defeats static analysis, so the union
// is the compiler's only window into it.

export const LEGACY_MSG_EVENT_NAMES = [
  'mev_msg_init_obj_evm',
  'mev_msg_is_debug_evm',
  'mev_msg_show_msg_evm',
  'mev_msg_init_rendered_html_evm',
  'mev_msg_show_new_msg_evm',
  'mev_msg_show_edit_draft_evm',
  'mev_msg_toggle_img_evm',
  'mev_msg_get_locked_evm',
  'mev_msg_un_lock_evm',
  'mev_msg_unlock_msg_evm',
  'mev_msg_is_super_msg_evm',
  'mev_msg_show_current_mode_evm',
  'mev_msg_menu_switcher_evm',
  'mev_msg_toggle_subs_evm',
  'mev_msg_toggle_menu_subs_evm',
  'mev_msg_subs_set_page_evm',
  'mev_msg_toggle_fav_evm',
  'mev_msg_toggle_glr_img_evm',
  'mev_msg_glr_uno_evm',
  'mev_msg_glr_uno_subs_evm',
  'mev_msg_move_subs_evm',
  'mev_msg_get_more_subs_evm',
  'mev_msg_refresh_subs_evm',
  'mev_msg_insert_new_subs_evm',
  'mev_msg_chain_load_more_subs_evm',
  'mev_msg_email_button_evm',
  'mev_msg_parents_btn_evm',
  'mev_msg_menu_li_over_evm',
  'mev_msg_toggle_foto_evm',
  'mev_msg_toggle_msg_evm',
  'mev_msg_check_sub_evm',
  'mev_msg_check_subs_evm',
  'mev_msg_toggle_enterpinform_evm',
  'mev_msg_toggle_edit_buttons_evm',
  'mev_msg_help_over_evm',
  'mev_msg_toggle_qr_evm',
  'mev_msg_save_qr_evm',
  'mev_msg_save_qr_over_evm',
  'mev_msg_qr_is_send_email_evm',
  'mev_msg_get_msg_values_evm',
] as const

export const LEGACY_EDITOR_HANDLER_NAMES = [
  'show_form',
  'show_form_2',
  'set_rough',
  'msg_mode',
  'save_form',
  'save_msg',
  'reset_msg',
  'mod',
  'check_name_key',
  'check_code_key',
  'html_is_to_protect',
  'html_toggle_code_key',
  'html_toggle_subject',
  'html_toggle_rich_edit',
  'html_toggle_bars',
  'html_toggle_more_settings',
  'html_toggle_personal_page',
  'html_toggle_atts',
  'to_address_remove',
  'resize',
  'sub_key',
  'is_advanced',
  'attaches_on_change',
  'attaches_on_result',
  'att_cancel',
  'att_remove',
  'att_toggle',
] as const

export type LegacyMsgEventName = (typeof LEGACY_MSG_EVENT_NAMES)[number]
export type LegacyEditorHandlerName = (typeof LEGACY_EDITOR_HANDLER_NAMES)[number]
export type LegacyHandlerName = LegacyMsgEventName | LegacyEditorHandlerName
